import angular from "angular";
import { react2angular } from "react18-react2angular";
import AdminDataDashboard from "@react/features/admin-reports/AdminDataDashboard";

export function registerAdminReportsBridge(moduleName = "ccqapp") {
    angular.module(moduleName).component(
        "adminDataDashboard",
        react2angular(
            AdminDataDashboard,
            [],                                  // no React props from template
            ["AdminDataDashboardClient", "$rootScope"] // DI tokens from AngularJS
        )
    );
}
